<template>
  <v-layout row align-start justify-start>
    <v-flex xs4>
      <site-component v-model="site"></site-component>
    </v-flex>
    <v-flex xs8>
      <area-component v-model="areas" :parent-id="site"></area-component>
    </v-flex>
  </v-layout>
</template>

<style scoped>

</style>

<script>
  import CascaderSite from "./cascaderSite.ts";
  export default CascaderSite;
</script>